export const RECEIVE_RESULTS = 'RECEIVE_RESULTS';

export function receiveResults(results) {
  return {
    type: RECEIVE_RESULTS,
    results
  }
}



// WEBPACK FOOTER //
// ./src/actions/results.js